module.exports = __webpack_public_path__ + "a0fabf60177c9a16a46dde6229918ecc.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/zh.json
// module id = 1160
// module chunks = 0